import { Icon } from "../../../primitives";

type MainNavItemProps = {
	icon:
		| "squares-2x2"
		| "clipboard"
		| "shield-check"
		| "building-office"
		| "archive-box-arrow-down"
		| "presentation-chart-line";
	label: string;
	active: boolean;
	onClick: () => void;
};

export const MainNavItem = (props: MainNavItemProps) => {
	return (
		<div
			title={props.label}
			data-sentry-unmask
			onClick={props.onClick}
			className={`w-full h-[45px] shrink-0 relative flex gap-x-0 md:gap-x-[6px] items-center cursor-pointer select-none ${!props.active ? "hover:bg-brand-primary-light" : ""}`}
		>
			<div
				className={`h-full absolute left-0 top-0 bottom-0 md:relative md:h-[38px] w-1 min-w-1 rounded-none md:rounded-full bg-brand-accent ${!props.active ? "opacity-0" : ""}`}
			></div>
			<div
				className={`group w-full flex md:grid md:grid-cols-[auto_1fr] justify-center md:justify-items-start items-center gap-x-2.5 h-full px-0 md:px-2.5 md:ml-0 bg-brand-primary-light ${!props.active ? "bg-opacity-0" : ""}`}
			>
				<div className="flex items-center justify-center h-5 w-5">
					<Icon
						type={props.icon}
						color="inverse"
						className={props.active ? "opacity-100" : "opacity-35"}
					/>
				</div>
				<div
					className={`hidden md:block text-[14px] font-semibold text-inverse ${!props.active ? "opacity-[.85]" : ""} group-hover:opacity-100`}
				>
					{props.label}
				</div>
			</div>
		</div>
	);
};
